// import { _.isFunction } from '../util/minilo'

/**
 * heuristic check that value is ol collection
 * @param value
 * @return {boolean}
 */
export function isCollection (value) {
  return value && _.isFunction(value.getArray)
}

/**
 * heuristic check that value is ol vector source
 * @param value
 * @return {*}
 */
export function isVectorSource (value) {
  return value && _.isFunction(value.getAttributions) && _.isFunction(value.getFeatureById)
}

/**
 * @param value
 * @return {*}
 */
export function isCircle (value) {
  return _.isFunction(value.getCenter) && _.isFunction(value.getRadius)
}

export function coalesce (...args) {
  return args.find(val => val != null)
}

export function* range (start, end, step = 1) {
  for (let i = start; i < end; i += step) {
    yield i
  }
}

export function reduce (collection, iteratee, initial) {
  let result = initial
  forEach(collection, (value, key) => {
    result = iteratee(result, value, key)
  })
  return result
}


export function makeWatchers (props, watcher) {
  return props.reduce((hash, prop) => {
    hash[prop] = watcher
    return hash
  }, {})
}

export function isObjectLike(value) {
    return value != null && typeof value === 'object'
}

export function isEqual(value, other) {
    if (value === other) {
        return true
    }
    if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        // eslint-disable-next-line no-self-compare
        return value !== value && other !== other
    }

    let valueProps = Object.keys(value)
    let otherProps = Object.keys(other)
    if (valueProps.length !== otherProps.length) {
        return false
    }

    let checked = []
    let traverse = (valueProps, otherProps) => {
        for (let i = 0, l = valueProps.length; i < l; i++) {
            let valueProp = valueProps[i]

            if (checked.includes(valueProp)) {
                continue
            }
            if (other.hasOwnProperty(valueProp) === false) {
                return false
            }

            let otherProp = otherProps[i]

            if (!isEqual(value[valueProp], other[otherProp])) {
                return false
            }

            checked.push(otherProp)
        }

        return true
    }

    if (traverse(valueProps, otherProps) === false) {
        return false
    }

    return traverse(otherProps, valueProps)
}



// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/utils/util.js